import { render, staticRenderFns } from "./LegacyTransferDataTable.vue?vue&type=template&id=6792edc8&"
import script from "./LegacyTransferDataTable.vue?vue&type=script&lang=js&"
export * from "./LegacyTransferDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports